// export const Base_URL = 'https://localhost:44370/api/HIS/';
// export const Base_URL = 'http://192.168.15.3/Test_HIS/api/Insurance/';
// export const Base_URL = 'http://192.168.15.3/Test_HISNew/api/HIS/';

// 'https://www.relainstitute.in/NewHIS_Live/api/his/Get_IP_insurance_Patient';

export const Base_URL = 'https://www.relainstitute.in/relalive/api/HIS/';

export const LOGIN_API = Base_URL + 'get_Ref_Login';
